import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MatDialogRef} from "@angular/material/dialog";
import {Constants} from "../../../utils/constants";
import {ContractsService} from "../../../services/contracts.service";
import {SnackService} from "../../../services/snack.service";
import {SplitCamelCasePipe} from "../../../pipes/split-camel-case.pipe";
import {ApiResponse} from "../../../classes/api-response";
import {AuthService} from "../../../services/auth.service";
import {Box} from "../../../model/box";
import {BoxesService} from "../../../services/boxes-service";
import {PatchBox} from "../../../model/patch-box";
import {hasAnyPermission, hasPermission, User} from "../../../model/user";


@Component({
  selector: 'aw-box-dialog-status-transition',
  templateUrl: './box-dialog-status-transition.component.html',
  styleUrls: ['./box-dialog-status-transition.component.scss']
})
export class BoxDialogStatusTransitionComponent implements OnInit {

  @Output() saved = new EventEmitter<void>();
  @Output() canceled = new EventEmitter<void>();
  saving = false;
  generalError?: ApiResponse;
  public selectedStatus = '';
  public boxStatus = Constants.boxStatuses;
  public currentStatus? = '';
  public statuses: string[] = [];
  loggedUser: User;

  constructor(
    public dialogRef: MatDialogRef<BoxDialogStatusTransitionComponent>,
    private contractService: ContractsService,
    private boxesService: BoxesService,
    private authService: AuthService,
    private snackService: SnackService,
    private splitCamelCase: SplitCamelCasePipe
  ) {


  }

  _box?: Box;

  @Input() set box(value: Box | undefined) {
    this._box = value;
    this.currentStatus = this._box?.status;
  }

  ngOnInit(): void {
    this.loggedUser = this.authService.loggedUser();


    if (hasAnyPermission(this.loggedUser, ["logistic", "admin"])) {
      if (this.currentStatus === this.boxStatus.new) {
        this.statuses.push(this.boxStatus.onTheShelf, this.boxStatus.toBeConfigured, this.boxStatus.broken);
      } else if (this.currentStatus === this.boxStatus.onTheShelf) {
        this.statuses.push(this.boxStatus.toBeConfigured, this.boxStatus.broken);
      } else if (this.currentStatus === this.boxStatus.toBeConfigured) {
        this.statuses.push(this.boxStatus.onTheShelf, this.boxStatus.broken);
      } else if (this.currentStatus === this.boxStatus.broken) {
        this.statuses.push(this.boxStatus.onTheShelf, this.boxStatus.toBeConfigured);
      } else if (this.currentStatus === this.boxStatus.assigned) {
        this.statuses.push(this.boxStatus.shipped);
      } else if (this.currentStatus === this.boxStatus.fail) {
        this.statuses.push(this.boxStatus.toShipBack);
      } else if (this.currentStatus === this.boxStatus.goingHome) {
        this.statuses.push(this.boxStatus.broken, this.boxStatus.toBeConfigured);
      }
    }
    if (hasAnyPermission(this.loggedUser, ["customer", "admin"])) {
      if (this.currentStatus === this.boxStatus.shipped) {
        this.statuses.push(this.boxStatus.delivered);
      } else if (this.currentStatus === this.boxStatus.delivered) {
        this.statuses.push(this.boxStatus.mounted);
      } else if (this.currentStatus === this.boxStatus.mounted) {
        this.statuses.push(this.boxStatus.available, this.boxStatus.unavailable, this.boxStatus.updating, this.boxStatus.fail);
      } else if (this.currentStatus === this.boxStatus.available) {
        this.statuses.push(this.boxStatus.unavailable, this.boxStatus.updating, this.boxStatus.fail, this.boxStatus.inUse);
      } else if (this.currentStatus === this.boxStatus.unavailable) {
        this.statuses.push(this.boxStatus.available, this.boxStatus.updating, this.boxStatus.fail);
      } else if (this.currentStatus === this.boxStatus.updating) {
        this.statuses.push(this.boxStatus.available, this.boxStatus.unavailable, this.boxStatus.fail);
      } else if (this.currentStatus === this.boxStatus.fail) {
        if (!hasPermission(this.loggedUser, "admin"))
          this.statuses.push(this.boxStatus.toShipBack);
        if (hasPermission(this.loggedUser, "admin"))
          this.statuses.push(this.boxStatus.available, this.boxStatus.unavailable, this.boxStatus.updating);
      } else if (this.currentStatus === this.boxStatus.inUse) {
        this.statuses.push(this.boxStatus.available, this.boxStatus.unavailable, this.boxStatus.fail, this.boxStatus.updating);
      } else if (this.currentStatus === this.boxStatus.toShipBack) {
        this.statuses.push(this.boxStatus.goingHome);
      }

    }
  }

  setStatus(): void {
    this.saving = true;
    const newBox = new PatchBox();
    newBox.status = this.selectedStatus;

    this.boxesService.updateBox(newBox, this._box?.id)
      .subscribe(
        () => {
          this.saving = false;
          this.snackService.success('Box status set to ' + this.splitCamelCase.transform(this.selectedStatus));
          this.dialogRef.close();
          this.saved.emit();
        },
        error => {
          this.saving = false;
          this.snackService.error(error.message);
          this.generalError = error;
        });

  }

}




